module.exports = __webpack_public_path__ + "media/images/favicon/site-673f5833fe4cee53c33ffd7ae8c0ce60.webmanifest";